export const PERMISSION_DEFAULTS = {
  view: false,
  update: false,
  delete: false
}

export const DEFAULT_PERMISSION_TYPES = [
  'Customers',
  'Invoices',
  'Payments',
  'Jobs',
  'Equipment',
  'Crews',
  'Employees',
  'Users',
  'Reports',
  'Finance Reports',
  'Rosters',
  'Timesheets',
  'Accounts Recv',
  'Dashboard',
  'Shed Inventory',
  'Services',
  'Entities',
  'Search Engine',
  'Settings',
  'Credits',
  'Deposits',
  'Tasks',
  'Uploads',
  'Vendors',
  'Projects',
  'Compensation',
  'Purchase Orders',
  'Approve POs',
  'Complete No Invoice',
  'Pool Maintenance Agreements',
  'Maintenance Routes',
  'Forecast',
  'Property Financials'
]

export const buildDefaultPermission = (type) => ({
  type,
  ...PERMISSION_DEFAULTS
})

export const DEFAULT_PERMISSIONS = DEFAULT_PERMISSION_TYPES.map(buildDefaultPermission)

export const mergeDefaultPermissions = (permissions = []) => {
  const existing = Array.isArray(permissions) ? permissions : []
  const byType = new Map()

  existing.forEach(permission => {
    if (permission && permission.type && !byType.has(permission.type)) {
      byType.set(permission.type, permission)
    }
  })

  DEFAULT_PERMISSIONS.forEach(permission => {
    if (!byType.has(permission.type)) {
      byType.set(permission.type, { ...permission })
    }
  })

  return Array.from(byType.values())
}
